<script setup lang="ts">
import type { PrimitivesValue } from '../../types/shared'

const WIDTH = 20

type Props = {
  color: string
  backgroundColor: string
  content: PrimitivesValue
  offsetX?: number
  offsetY?: number
}

const props = withDefaults(defineProps<Props>(), {
  offsetX: 0,
  offsetY: 0,
})

const componentStyles = computed(() => {
  return {
    color: props.color,
    backgroundColor: props.backgroundColor,
    left: `calc(100% - ${WIDTH / 2 + props.offsetX}px)`,
    bottom: `calc(100% - ${WIDTH / 2 + props.offsetY}px)`,
  }
})
</script>

<template>
  <div class="app-badge">
    <slot />

    <span
      v-if="content"
      data-test-id="badge-content"
      class="app-badge__content"
      :style="componentStyles"
    >
      {{ content }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.app-badge {
  position: relative;
  display: flex;

  &__content {
    position: absolute;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 4px 6px;
    font-size: 12px;
    font-weight: 800;
    text-align: center;
    text-indent: 0;
    white-space: nowrap;
    pointer-events: none;
    border-radius: 20px;
  }
}
</style>
